module.exports = __webpack_public_path__ + "static/sport/title.24904b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/title.png
// module id = hNZi
// module chunks = 0